export enum FeatureToggle {
  emergingBrandsPortal = 'rt_emerging_brands_portal',
  nutritionalInfo = 'rt_emerging_brands_portal_nutritional_info',
  emergingBrandsPortalTopBrandsBanner = 'rt_emerging_brands_portal_top_brand_banner',
  noAccessEmergingBrandPortal = 'rt_not_access_emerging_brands_portal',
}
